export default "__VITE_ASSET__a06e9962__"